// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
import {Version} from 'app/_interfaces/version.interface';
export const VERSION: Version = {
    "dirty": false,
    "raw": "a236bec",
    "hash": "a236bec",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "a236bec",
    "semverString": null,
    "version": "2.1.0",
    "buildDate": "2026-08-13T18:00:15.284Z"
};
/* tslint:enable */
